module.exports = __webpack_public_path__ + "b768ed48c1f3734f532a3b012c0110c8.svg";